module.exports = __webpack_public_path__ + "aaa990d0116db1682430a1f611c16552.svg";